import React, { useEffect, useContext, useMemo } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import base64 from 'base-64'

import { BusinessContext } from '../../contexts/business'

import useBusinessLogo from '../../utils/hooks/useBusinessLogo'

import Header from '../../components/Header'
import Loading from '../../components/Loading'


import {
  Container,
  Logo,
  ContentContainer,
  ActionsContainer,
  ActionButton,
  ActionButtonTitle,
  SchedulingIcon,
  SchedulingsIcon
} from './styles'


function BusinessData() {

  const { getBusiness, business, setEncodedBusinessId } = useContext(BusinessContext)
  let [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { logoUrl, isFallback } = useBusinessLogo(business?.url)

  const decodedBusinessId = useMemo(() => {

    const encodedId = searchParams.get('business_id')
    if (!encodedId) return null

    try {
      const standardBase64 = encodedId.replace(/-/g, '+').replace(/_/g, '/')

      const decoded = base64.decode(standardBase64)
      return parseInt(decoded, 10)
    } catch (e) {
      console.error("Falha ao decodificar business_id:", e)
      return null
    }
  }, [searchParams])

  //const businessId = searchParams.get('business_id')

  // useEffect(() => {
  //   if (businessId) {
  //     getBusiness(businessId)
  //   }
  // }, [])

  useEffect(() => {

    const encodedIdFromUrl = searchParams.get('business_id')
    if (encodedIdFromUrl) {
      setEncodedBusinessId(encodedIdFromUrl)
    }

    if (decodedBusinessId) {
      getBusiness(decodedBusinessId)
    } else {
      console.log("Nenhum ID de empresa válido fornecido na URL.")
    }

  }, [decodedBusinessId, getBusiness])

  useEffect(() => {   

    if (business?.url) {
      let link = document.querySelector("link[rel~='icon']")
      if (!link) {
        link = document.createElement('link')
        link.rel = 'icon'
        document.getElementsByTagName('head')[0].appendChild(link)
      }
      link.href = business?.url
    }
  }, [business])

  if (!business) {
    return (
      <Loading />
    )
  }

  return (
    <Container className='container-fluid'>
      <Header />

      <ContentContainer>

        <Logo url={logoUrl} isFallback={isFallback} />

        <ActionsContainer>
          <ActionButton onClick={() => navigate('/scheduling_add')} >
            <SchedulingIcon />
            <ActionButtonTitle>Agendar</ActionButtonTitle>
          </ActionButton>

          <ActionButton onClick={() => navigate('/scheduling_list')}>
            <SchedulingsIcon />
            <ActionButtonTitle>Agendamentos</ActionButtonTitle>
          </ActionButton>

        </ActionsContainer>

      </ContentContainer>

    </Container>
  )
}

export default BusinessData